import PropTypes from 'prop-types';
import React from 'react';
import { FeedCard, FeatureCard } from '@surfline/quiver-react';
import articlePropTypes from '../../propTypes/article';

const getFeatureArticleImage = media => media.promobox1x || media.feed2x;

const FeedArticle = ({ article, doTrackFeed, feature, type, promoPosition }) => (
  <div className="sl-feed-article">
    {feature ? (
      <FeatureCard
        isPremium={article.premium}
        small={type === 'feedSmall'}
        imageUrl={article.media ? getFeatureArticleImage(article.media) : null}
        newWindow={article.newWindow}
        permalink={article.permalink}
        title={article.content.title}
        displayTitle={article.content.displayTitle}
        feedSuperheader={article.feedSuperheader}
        onClickLink={() =>
          doTrackFeed('Clicked Home Feed Link', {
            destinationUrl: article.permalink,
            mediaType: article.media && article.media.type ? article.media.type : null,
            contentId: article.id,
            title: article.content.title,
            category: type === 'feedSmall' ? 'Feed Small Article' : 'Feed Large Article',
            contentType: 'Surf News',
            tags: article.tags,
            locationCategory: 'homepage curated feed',
          })
        }
      />
    ) : (
      <FeedCard
        isPremium={article.premium}
        category={article.tags[0]}
        imageUrl={article.media ? article.media.feed2x : null}
        newWindow={article.newWindow}
        subtitle={article.content.subtitle}
        title={article.content.title}
        displayTitle={article.content.displayTitle}
        createdAt={article.createdAt}
        permalink={article.permalink}
        onClickLink={() =>
          doTrackFeed('Clicked Home Feed Link', {
            destinationUrl: article.permalink,
            mediaType: article.media && article.media.type ? article.media.type : null,
            contentId: article.id,
            title: article.content.title,
            contentType: 'Surf News',
            tags: article.tags,
            category: type === 'promo' ? 'Promo Article' : 'Curated Article',
            locationCategory: type === 'promo' ? 'homepage promobox' : 'homepage curated feed',
            promoPosition: promoPosition + 1 || null,
          })
        }
        onClickTag={tag =>
          doTrackFeed('Clicked Home Feed Link', {
            destinationUrl: tag.url,
            mediaType: tag.name,
            contentId: article.id,
            title: article.content.title,
            contentType: 'Surf News',
            tags: article.tags,
            category: type === 'promo' ? 'Promo Article' : 'Curated Article',
            locationCategory: type === 'promo' ? 'homepage promobox' : 'homepage curated feed',
            promoPosition: promoPosition + 1 || null,
          })
        }
      />
    )}
  </div>
);

FeedArticle.propTypes = {
  article: articlePropTypes.isRequired,
  doTrackFeed: PropTypes.func.isRequired,
  feature: PropTypes.bool,
  promoPosition: PropTypes.number,
  type: PropTypes.oneOf(['curated', 'feedLarge', 'feedSmall', 'promo']).isRequired,
};

FeedArticle.defaultProps = {
  feature: false,
  promoPosition: null,
};

export default FeedArticle;
